export const tr = {
    'allowed-page-id-is-not-number': '"pageld", pozitif bir sayı olmalıdır. Hatalı değerler: {values}',
    'allowed_page-ids-limit-reached': "engellenen pageId'lerin maksimum sayısı: {limit}",
    and: 've',
    'autobuget-campaign-name': 'Otomatik bütçeli kampanya',
    'banned-domains-limit-reached': 'Maksimum site/harici ağ sayısı: {limit}',
    'content-promotion-campaign-name': '"İçerik promosyonu" kampanyası',
    'empty-campaign-name': 'Kampanya adı belirtilmedi',
    experiments: 'Denemeler',
    'invalid-disabled-ips-number': 'Engellenebilen IP adreslerinin maksimum sayısı: {maxIpsNumber}',
    'invalid-ips': 'IP adresleri yanlış belirtildi: {ips}',
    'key-goals': 'Anahtar hedefler',
    'max-length-name': 'Kampanya adı {count} karakteri geçmemelidir',
    'metrika-counters-is-unavailable': {
        one: '{counters} Metrica sayacı, silindiği veya yetkiniz olmadığı için kampanyaya bağlanamıyor.',
        some: '{counters} Metrica sayaçları, silindiği veya yetkiniz olmadığı için kampanyaya bağlanamıyor.',
        many: '{counters} Metrica sayaçları, silindiği veya yetkiniz olmadığı için kampanyaya bağlanamıyor.',
        none: '{counters} Metrica sayaçları, silindiği veya yetkiniz olmadığı için kampanyaya bağlanamıyor.'
    },
    'name-campaign': '{campaignName}, No.: {count}, Tarih: {date}',
    'price-package-campaign-name': 'todo',
    'required-field': 'Zorunlu alan',
    'tgo-campaign-name': 'Metin-grafik reklam kampanyası',
    'warning-about-metrika-counters': 'Sayaçlar silindiğinde ilgili hedeflere göre tüm {fields} ayarları kaybolur'
};
